import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { BookCallDialog } from "@/components/site/BookCall";
import ContactPage from "@/pages/ContactPage";

export default function BookCallPage() {
  const [open, setOpen] = useState(false);
  const [params] = useSearchParams();
  useEffect(() => { setOpen(true); }, []);
  return (
    <>
      <ContactPage embedded />
      <BookCallDialog open={open} onOpenChange={setOpen} source={params.get("src") || "share-link"} />
    </>
  );
}
